// extracted by mini-css-extract-plugin
module.exports = {"formControl":"kontakt-module--formControl--3WEJU","submit":"kontakt-module--submit--2PEmx","vip":"kontakt-module--vip--1dLFs"};